import { Slash } from 'lucide-react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBreadCrumbs } from '@/hooks/useBreadCrumbs';
import { appLogger } from '@/utils/logger';

interface BreadcrumbsProps {
  spaceId?: string;
  datasetId?: string;
  collectionId?: string;
}

export const Breadcrumbs: FC<BreadcrumbsProps> = () => {
  const breadcrumbs = useBreadCrumbs();
  const navigate = useNavigate();

  const handleNavigation = (link: string) => {
    if (link && typeof link === 'string' && link !== '') {
      navigate(link);
    } else {
      appLogger.error('Attempting to navigate to invalid route:', link);
    }
  };
  return (
    <nav aria-label="Breadcrumb" className="flex">
      <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        {breadcrumbs?.map((breadcrumb, index) => (
          <li className="inline-flex items-center" key={breadcrumb.name || `breadcrumb-${index}`}>
            <div className="flex items-center">
              <p
                className="inline-flex items-center text-[16px] font-medium text-[#4D4D4D] cursor-pointer"
                onClick={() => handleNavigation(breadcrumb.link)}
              >
                {breadcrumb.name}
              </p>
              {index + 1 !== breadcrumbs.length && <Slash className="text-[#4D4D4D]" />}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
};
